<template>
    <v-row justify="center">
        <v-dialog v-model="SaveToOneboxDialog" scrollable max-width="400px" persistent>
            <v-card>
                <v-card-title>
                    {{ $t('Dialog.Saveonebox.titleaccount') }}
                    <v-spacer></v-spacer>
                    <v-btn dark icon color="grey" @click="closeDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="progress" style="height: 300px; padding-top: 20px; padding-left: 0px; padding-right: 0px;">
                    <v-row class="justify-center align-center" style="height: 300px;">
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    </v-row>
                </v-card-text>
                <v-card-text v-else style="height: 300px; padding-top: 20px; padding-left: 10px; padding-right: 10px;" class="chat-container">
                    <v-treeview v-model="tree" activatable :items="items" item-text="account_name" item-key="folder_id" return-object
                        :load-children="fetch" open-on-click :open.sync="open" :active.sync="active">
                        <template v-slot:prepend="{ open }">
                            <v-icon>
                                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
export default {
    props: {
        SaveToOneboxDialog: Boolean,
        SaveToOneboxDetail: Object,
        tokenuser: String,
    },
    data() {
        return {
            list_account: [],
            progress: false,
            tree: [],
            isLoading: false,
            open: [],
            active: [],
        }
    },
    computed: {
        items() {
            return this.list_account
        },
    },
    watch: {
        active() {
            // console.log("active => ", this.active);
            this.saveFile(this.active[0])
        },
        SaveToOneboxDialog () {
            if (this.SaveToOneboxDialog) {
                this.getListAccount()
            }
        },
    },
    methods: {
        closeDialog() {
            this.$emit('closeComponents', { name: 'onebox', value: false })
        },
        async getListAccount() {
            this.progress = true;
            await this.axios.post(process.env.VUE_APP_API_EVENT + '/api/box/get_account_byuserid', {
                user_id: this.tokenuser
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.progress = false;
                    // console.log(response.data.data);
                    this.list_account = response.data.data.map(v => ({ ...v, children: [] }));
                    // console.log(this.list_account);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        saveFile (item) {
            this.$swal({
                text: this.$t('Alert.Saveonebox'),
                type: "warning",
                showCancelButton: true,
                confirmButtonText: this.$t('AnswerQuestion.ok'),
                cancelButtonText: this.$t('AnswerQuestion.cancel'),
                reverseButtons: true,
                showCloseButton: true,
                allowOutsideClick: false,
            }).then((result) => {
                // console.log(result);
                if(result.value) {
                    this.axios.post(process.env.VUE_APP_API_EVENT + '/api/box/savefile', {
                        folder_id: item.folder_id,
                        account_id: item.account_id,
                        tokenmessage: this.SaveToOneboxDetail.tokenmessage
                    }).then((response) => {
                        if (response.data.status === 'success') {
                            this.$swal({
                                title: this.$t('Alert.Success.success'),
                                text: this.$t('Dialog.Saveonebox.sendFiletoOnebox'),
                                type: 'success',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            this.$emit('closeComponents', { name: 'onebox', value: false })
                        }
                    }).catch(err => {
                        console.log(err.response);
                        this.$swal({
                            text: err.response.data.message,
                            type: "warning",
                            showCancelButton: false,
                            showCancelButton: false,
                            showCloseButton: true,
                            allowOutsideClick: false,
                            confirmButtonText: this.$t('AnswerQuestion.ok'),
                        })
                    })
                }
            })
        },
        async fetch(item) {
            // console.log('fetch', item);
            const keyMap = { folder_name: 'account_name' };
            try {
            const response = await this.axios.post(
                `${process.env.VUE_APP_API_EVENT}/api/box/get_mainfolder_byaccountid`,
                { account_id: item.account_id }
            );

            // ตรวจสอบว่าข้อมูลที่ได้รับจาก API มีโครงสร้างที่ถูกต้อง
            if (response.data && response.data.data) {
                const transformedData = response.data.data.map(obj => {
                // เปลี่ยนชื่อคีย์ตาม keyMap
                const transformedObj = Object.fromEntries(
                    Object.entries(obj).map(([key, value]) => 
                    [keyMap[key] || key, value]
                    )
                );

                // เพิ่มคีย์ใหม่เข้าไปในแต่ละวัตถุ
                transformedObj.account_id = item.account_id; // ตัวอย่างการเพิ่มคีย์ใหม่
                return transformedObj;
                });

                // เพิ่มข้อมูลที่แปลงแล้วเข้าไปใน children
                item.children.push(...transformedData);
            } else {
                console.warn('Unexpected API response structure:', response);
                this.$swal({
                    text: response.data.status,
                    type: "warning",
                    showCancelButton: false,
                    showCancelButton: false,
                    showCloseButton: true,
                    allowOutsideClick: false,
                    confirmButtonText: this.$t('AnswerQuestion.ok'),
                })
            }
            } catch (err) {
                console.warn('Error while fetching or processing data:', err);
                this.$swal({
                    text: err.response.data.message,
                    type: "warning",
                    showCancelButton: false,
                    showCancelButton: false,
                    showCloseButton: true,
                    allowOutsideClick: false,
                    confirmButtonText: this.$t('AnswerQuestion.ok'),
                })
            }
        },
    },
}
</script>
<style scopted>
.chat-container {
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding: 10px 10px;
}

.chat-container::-webkit-scrollbar-thumb {
    background: #888 !important;
    border-radius: 10px;
    background-clip: padding-box !important;
}

.chat-container::-webkit-scrollbar {
    width: 6px;
}
</style>